import type { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface BannerProps {
	children: ReactNode;
}

const Banner: FC<BannerProps> = ({ children }) => {
	return (
		<Box
			sx={{
				position: 'static',
				left: 0,
				width: '100%',
				bgcolor: '#ff9015',
				color: 'white',
				textAlign: 'center',
				py: 2,
				zIndex: 1,
			}}
		>
			<Typography sx={{ fontSize: { xs: '1rem', sm: '1.15rem' } }}>{children}</Typography>
		</Box>
	);
};

export default Banner;
